<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <vs-table ref="table" v-model="selected" pagination :max-items="itemsPerPage" search :data="stores">
      <!-- multiple -->

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <vs-button class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" color="primary" type="border" icon-pack="feather" icon="icon-plus" @click="addNewData">Agregar Nuevo</vs-button>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ stores.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : stores.length }} de {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th>Imagen</vs-th>
        <vs-th sort-key="id">Id</vs-th>
        <vs-th sort-key="name">Tienda</vs-th>
        <vs-th sort-key="type_id">Tipo</vs-th>
        <vs-th sort-key="tiptap_commission_percent">Comisión</vs-th>
        <vs-th sort-key="status">Estado</vs-th>
        <vs-th>Acciones</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

              <vs-td class="img-container">
                <img v-if="tr.commerce.image" :src="$baseUrlImg + tr.commerce.image" class="product-img" />
                <div v-else class="mr-8 rounded h-24 w-24 primary flex items-center flex-col justify-center" style="background-color: #f5f5f5"><feather-icon icon="ImageIcon" style="color:lightgray"></feather-icon></div>
              </vs-td>

              <vs-td>
                <p class="font-medium">{{ tr.id }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.name }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.commerce.id_type === 1 ? "Escuela" : "Comercio" }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name truncate">{{ tr.tiptap_commission_percent }} %</p>
              </vs-td>

              <vs-td>
                <vs-chip :color="getOrderStatusColor(tr.status)" class="product-order-status">{{ tr.status === 0 ? "Inactivo" : "Activo" }}</vs-chip>
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />
                <feather-icon :icon="tr.status == 1 ? 'TrashIcon' : 'RefreshCwIcon'" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr)" />
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
    <!-- <store-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData"/> -->
  </div>
</template>

<script>
import StoreSidebar from './components/StoreSidebar.vue'
import moduleMarketplace from '@/store/marketplace/moduleMarketplace.js'
import moduleDataListInstitutions from "@/store/data-list-institutions/moduleDataList.js"
import moduleUserManagement from "@/store/user-management/moduleUserManagement.js"

export default {
  components: {
    StoreSidebar
  },
  data() {
    return {
      selected: [],
      itemsPerPage: 10,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
    }
  },
  computed: {
    currentPage() {
      if(this.isMounted) {
        return this.$refs.table ? this.$refs.table.currentx : 1
      }
      return 0
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.stores.length
    },
    stores() {
      return this.$store.state.marketplace.stores
    },
  },
  methods: {
    addNewData() {
      this.$router.push({name: 'store-add'});
      // this.sidebarData = {}
      // this.toggleDataSidebar(true)
    },
    deleteData(tr) {
      const obj = {
        id_store: tr.id
      }

      if (tr.status == 1)
        this.deleteStore(obj)
      else {
        obj.status = 1
        obj.tiptap_commission_percent = tr.tiptap_commission_percent
        obj.name = tr.name
        obj.admins = tr.admins
        this.restoreStore(obj)
      }

    },
    restoreStore(store) {
      this.$store.dispatch("marketplace/updateStore", store)
      .then(response => {
        if(!response.status)
          throw new Error(response.msg)

        this.showAddSuccess()
      })
      .catch(error => { this.showError(error) })
    },
    deleteStore(store) {
      this.$store.dispatch("marketplace/deleteStore", store)
      .then(response => {
        if(!response.status)
          throw new Error(response.msg)

        this.showAddSuccess()
      })
      .catch(error => { this.showError(error) })
    },
    editData(data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.$router.push({name: 'store-edit', params: { idStore: data.id }});

      // this.sidebarData = data
      // this.toggleDataSidebar(true)
    },
    showNotify(type,title,text) {
      this.$vs.notify({
        color: type || 'success',
        title: title || 'Correcto!',
        text: text || '',
        time: 8000,
        position: 'top-center',
      })
    },
    getOrderStatusColor(status) {
      if(status === 0) return "danger"
      if(status === 1) return "success"
      //if(status == 'canceled') return "danger"
      return "primary"
    },
    getPopularityColor(num) {
      if(num > 9) return "success"
      if(num >7) return "primary"
      if(num >= 5) return "warning"
      if(num < 5) return "danger"
      return "primary"
    },
    toggleDataSidebar(val=false) {
      this.addNewDataSidebar = val
    },
    showError(msg) {
      this.$vs.notify({
        color: 'danger',
        title: 'Error',
        text: msg || 'No se pudo completar el proceso.',
        time: 8000,
        position: 'top-center',
        iconPack: 'feather',
        icon:'icon-alert-circle',
      })
    },
    showAddSuccess() {
      this.$vs.notify({
        color: 'success',
        title: 'Tienda',
        text: 'Se han guardado los cambios.',
        time: 8000,
        position: 'top-center',
        iconPack: 'feather',
        icon:'icon-check',
      })
    },
    fetchStores() {
      // getStores
      this.$store.dispatch("marketplace/getStores", '')
      .catch(error => this.showError(error))
    }
  },
  created() {
    if(!moduleMarketplace.isRegistered) {
        this.$store.registerModule('marketplace', moduleMarketplace)
        moduleMarketplace.isRegistered = true
    }
    this.fetchStores()
  },
  mounted() {
    this.isMounted = true;
  },
  beforeMount() {
    if(!moduleDataListInstitutions.isRegistered) {
      this.$store.registerModule('dataListInstitutions', moduleDataListInstitutions)
      moduleDataListInstitutions.isRegistered = true
    }
    if(!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }

    this.$store.dispatch("dataListInstitutions/getSchools")
  }
}
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;


      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              // width: 1rem;
              // background: #fff;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .product-img {
                height: 110px;
              }
            }
            .product-stock-min {
              max-width: 6rem;
              text-align: center;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
